import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { ShInputTextComponent, TextValueAccessor } from '@gbr-monorepo/gbr-shui';
import { TranslateModule } from '@ngx-translate/core';
import { SeasonFormGroup } from '../../../models/season-form.model';
import { SeasonBaseFormHeaderComponent } from '../season-base-form/season-base-form-header/season-base-form-header.component';
import { SeasonBaseFormComponent } from '../season-base-form/season-base-form.component';

@Component({
    selector: 'app-budget',
    templateUrl: './budget.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ShInputTextComponent,
        TextValueAccessor,
        ReactiveFormsModule,
        TranslateModule,
        SeasonBaseFormHeaderComponent
    ]
})
export class BudgetComponent extends SeasonBaseFormComponent {
    public readonly budget = input.required<SeasonFormGroup['budget']>();

    public calendarYearBudgetLabel = 'seasons.season-creation.budget.calendar-year-budget';
    public shortestSubsidyLabel = 'seasons.season-creation.budget.shortest-subsidy';
    public longestSubsidyLabel = 'seasons.season-creation.budget.longest-subsidy';

    protected getFormControl(): AbstractControl {
        return this.budget();
    }

    public preventNonNumericInput(event: KeyboardEvent): void {
        if (['e', 'E', '+', '-', '.', ','].includes(event.key)) {
            event.preventDefault();
        }
    }
}
